import React from 'react';

import MetricSection from '/component/partial/MetricSection';
import {MetricsSection} from '/constant/TestIDs';
import {BONUSES} from '/enum/popover.enum';
import {useTranslation} from '/provider/TranslationProvider';
import {generateCallback} from '/util/component.util';

import EarningDeltaItem from './EarningDeltaItem';
import EarningTouchableDeltaItem from './EarningTouchableDeltaItem';

interface EarningsSectionProps {
  commission: number | null;
  commissionDelta: number | null;
  bonuses: number | null;
  bonusesDelta: number | null;
  onShowInfoPopover: () => void;
  onOpenModal: (modalName: string) => void;
}

export const EarningsSection: React.FC<EarningsSectionProps> = ({
  commission,
  commissionDelta,
  bonuses,
  bonusesDelta,

  // HIDDEN: CONNAPP-580
  // totalIncome,
  // totalIncomeDelta,
  onShowInfoPopover,

  onOpenModal,
}: EarningsSectionProps) => {
  const {ts} = useTranslation('screen.performance.section.earnings');
  const listItems = [
    {
      label: ts('commission', 'Commission'),
      value: commission,
      delta: commissionDelta,
      period: ts('period.lastWeek', 'Last week'),
      component: EarningDeltaItem,
      testID: MetricsSection.metricCommission,
    },
    {
      label: ts('bonuses', 'Bonuses'),
      value: bonuses,
      delta: bonusesDelta,
      period: ts('period.lastMonth', 'Last month'),
      component: EarningTouchableDeltaItem,
      onCustomPress: generateCallback({
        func: onOpenModal,
        params: {modalName: BONUSES},
      }),
      testID: MetricsSection.metricBonuses,
    },
  ];
  // listItems.push({
  //   label: tt('totalIncome', 'Total Income'),
  //   value: totalIncome,
  //   delta: totalIncomeDelta,
  //   period: tt('period.lastMonth', 'Last month'),
  //   component: EarningDeltaItem,
  //   testID: MetricsSection.metricTotalIncome,
  // });

  return (
    <MetricSection
      analyticsTitle="Earnings"
      infoAccessibilityLabel={ts(
        'accessibilityLabel',
        'Earnings Section Information button',
      )}
      testID={MetricsSection.metricSectionEarnings}
      title={ts('heading', 'Earnings')}
      listItems={listItems}
      onInfoPress={generateCallback({
        func: onShowInfoPopover,
        params: {
          heading: ts('info.heading', 'Earnings'),
          body: ts(
            'info.body',
            'Check out how much you’ve earned – in your weekly commissions or in monthly bonuses, plus how you compare to the last paid period.',
          ),
        },
      })}
    />
  );
};

export default EarningsSection;
